import { render, staticRenderFns } from "./eg_modal.vue?vue&type=template&id=54ea09b8&scoped=true&"
import script from "./eg_modal.vue?vue&type=script&lang=js&"
export * from "./eg_modal.vue?vue&type=script&lang=js&"
import style0 from "./eg_modal.vue?vue&type=style&index=0&id=54ea09b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea09b8",
  null
  
)

export default component.exports